import CustomAccordion from "./CustomAccordion";
const NotificationAccordion = CustomAccordion;
export default NotificationAccordion;
